let html = `
<svg><use xlink:href="#sprite-bell"></use></svg>
`

export default html